import { useState } from 'react';
import { Button as MaterialButton, Tooltip } from '@mui/material';
import { ExportProspectsModal } from './export-contacts-modal';
import { Download } from 'lucide-react';
import { useContactExport as useProspectExport } from '../../../../hooks/use-contact-export';
import { useAppSelector } from '../../../../../../redux/store/configureStore';
import { useProspects } from '../../../../../../hooks/use-prospects';
import { ProspectDto } from '@zaplify/prospects';

export const ExportContactsButton = ({
    selected,
    prospectIds,
    prospectCollectionId,
}: {
    selected: Record<string, ProspectDto>;
    prospectIds: string[];
    prospectCollectionId: string;
}) => {
    const [isExportProspectsModalOpen, setIsExportProspectsModalOpen] = useState(false);
    const { getProspects } = useProspects();
    const { downloadContacts } = useProspectExport();
    const userOrganizationId = useAppSelector((state) => state.user.zaplifyUser?.userOrganization?.id);

    const handleSubmit = async (format: 'csv' | 'xlsx', selectedContacts: 'selected' | 'all') => {
        if (selectedContacts === 'selected') {
            downloadContacts(Object.values(selected), format);
        } else {
            let page = 1;
            let userContacts = [];
            let fetchedContacts: { prospects: ProspectDto[]; count: number };

            do {
                fetchedContacts = await getProspects({
                    userOrganizationId,
                    pageSize: 500,
                    page: page,
                    prospectCollectionId: prospectCollectionId,
                });
                if (fetchedContacts.prospects.length > 0) {
                    downloadContacts(fetchedContacts.prospects, format, `_page_${page}`);
                    userContacts = userContacts.concat(fetchedContacts);
                }
                page++;
            } while (fetchedContacts.prospects.length === 500);
        }
    };

    return (
        <>
            <Tooltip title="Export Prospects to CSV or Excel" placement="top" arrow>
                <MaterialButton
                    data-cy="export-prospects-button"
                    className="button no-blue-icon"
                    startIcon={<Download strokeWidth={1} />}
                    onClick={() => setIsExportProspectsModalOpen(true)}
                >
                    Export...
                </MaterialButton>
            </Tooltip>
            <ExportProspectsModal
                open={isExportProspectsModalOpen}
                numberAllProspects={prospectIds.length}
                numberSelectedProspects={Object.values(selected ?? {}).length}
                onClose={() => setIsExportProspectsModalOpen(false)}
                onSubmit={handleSubmit}
            />
        </>
    );
};
